import { Injectable } from '@angular/core';
import { AngularFireMessaging } from '@angular/fire/compat/messaging';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FirebaseMessagingService {
  currentMessage = new BehaviorSubject<any>(null);

  constructor(private afMessaging: AngularFireMessaging) {}

  requestPermission() {
    Notification.requestPermission().then((permission) => {
      console.log('Notification permission:', permission);
      if (permission === 'granted') {
        this.afMessaging.requestToken.subscribe({
          next: (token) => {
            console.log('FCM Token:', token);
            localStorage.setItem('pushToken', token)
          },
          error: (err) => console.error('Token error:', err)
        });
      }
    });
  }

  listen() {
    this.afMessaging.messages.subscribe((payload: any) => {
      console.log('Foreground message received:', payload);
      alert(payload.notification?.title + '\n' + payload.notification?.body);
      // Show popup manually
      if (Notification.permission === 'granted') {
        const { title, body } = payload.notification;
        new Notification(title, {
          body: body,
          icon: '/assets/icons/icon-72x72.png'
        });
      }
  
      this.currentMessage.next(payload);
    });
  }
}
